class LqdVerticalSlideshowHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initInView();
    this.initSlideshow();

  }

  getDefaultSettings() {
    return {
      selectors: {
        inViewElement: '[data-inview]',
        slideshowElement: '[data-lqd-slideshow]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $inViewElement: this.$element.find(selectors.inViewElement),
      $slideshowElement: this.$element.find(selectors.slideshowElement),
    }
  }

  initInView() {

    this.elements.$inViewElement.liquidInView();

  }

  initSlideshow() {

    this.elements.$slideshowElement.liquidSlideshow();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdVerticalSlideshowHandler, { $element } );
};